import {
  hvGetToken,
  hvUpdateEmail,
  hvUpdatePhone,
  hvUpdateBank,
  hvUpdateSegment,
} from "@/services/rest/hvAPI";
import { getUserDetails } from "@/services/rest/user-details";

const getCommonPayload = (userData) => {
  const dp = userData.dp;

  return {
    dpId: dp.substring(0, 8),
    boId: dp,
    date: new Intl.DateTimeFormat("en-UK", { dateStyle: "short" }).format(
      new Date()
    ),
    // "date": new Date().toISOString().substring(0,10),
    tradingClientId: userData.uniqueCientCode,
    pan: userData.panNumber,
    // "name": userData.nameAsITD,
    aadhaarName: userData.nameAsAadhar,
    panName: userData.nameAsPAN,
    // TODO: verify name field
  };
};
const getEmailPayload = (userData, txnResponse) => {
  return {
    ...getCommonPayload(userData),
    existingEmail : txnResponse.oldEmail,
    phoneNumber : userData.phone,
    applicationNumber : txnResponse.id.toString(),
    fatherOrSpouseName : userData.fatherName,
    declarationPlace : userData.permanentAddressAsDigilockerAadhaar.city,
    maritalStatus : userData.maritalStatus,
    selfie : userData.selfie?.url || "NA",
    wetSignature : userData.signature?.url || "NA",
    declarationDate : txnResponse.applicationDate,
    ipvDate : txnResponse.applicationDate,
    ipvEmpName : txnResponse.ipvEmployeeName,
    ipvEmpCode : txnResponse.ipvEmployeeCode,
    ipvEmpDes : txnResponse.ipvEmployeeDescription,
    employeeSignature : txnResponse.EmployeeSignature
  };
};

const getPhonePayload = (userData, txnResponse) => {
  return {
    ...getCommonPayload(userData),
    existingPhone: txnResponse.oldPhone,
    customerEmail: userData.email,
    applicationNumber : txnResponse.id.toString(),
    fatherOrSpouseName : userData.fatherName,
    declarationPlace : userData.permanentAddressAsDigilockerAadhaar.city,
    maritalStatus : userData.maritalStatus,
    selfie : userData.selfie?.url || "NA",
    wetSignature : userData.signature?.url || "NA",
    declarationDate : txnResponse.applicationDate,
    ipvDate : txnResponse.applicationDate,
    ipvEmpName : txnResponse.ipvEmployeeName,
    ipvEmpCode : txnResponse.ipvEmployeeCode,
    ipvEmpDes : txnResponse.ipvEmployeeDescription,
    employeeSignature : txnResponse.EmployeeSignature
  };
};

const getBankPayload = (userData,txnResponse) => {
  return {
    ...getCommonPayload(userData),
    existingBankName: userData.bankDetails[0].bankName,
    existingBankAccNumber: userData.bankDetails[0].bankAccountNumber,
    existingIFSC: userData.bankDetails[0].bankIFSCNumber,
    customerEmail: userData.email,
    customerPhone: userData.phone,
    existingMicr: "NA",
    existingBankBranch: userData.bankDetails[0].bankBranch,
    documentRecievedBranchRoName: "NA",
    documentRecievedTime: "NA",
    employeeName: txnResponse.EmployeeName || "NA",
    employeeCode: txnResponse.EmployeeCode || "NA",
    employeeSign: txnResponse.EmployeeSignature || "NA",
    documentRecievedDate: "NA",
    clientName2: "NA",
    clientName3: "NA"
  };
};

const getSegmentPayload = (userData,txnResponse) => {
  return {
    tradingClientId: userData.uniqueCientCode,
    pan: userData.panNumber,
    // "name": userData.nameAsITD,
    aadhaarName: userData.nameAsAadhar,
    panName: userData.nameAsPAN,

    phoneNumber: userData.phone,
    email: userData.email
  };
};

const workFlowMap = {
  emailUpdate: {
    payloadMethod: getEmailPayload,
    txnMethod: hvUpdateEmail,
  },
  phoneUpdate: {
    payloadMethod: getPhonePayload,
    txnMethod: hvUpdatePhone,
  },
  bankUpdate: {
    payloadMethod: getBankPayload,
    txnMethod: hvUpdateBank,
  },
  segmentUpdate: {
    payloadMethod: getSegmentPayload,
    txnMethod: hvUpdateSegment,
  },
};


export const loadHyperverge = async (workFlow) => {
  return new Promise(async(resolve, reject) => {
    try {

      const userData = await getUserDetails([
        "Onboarding.SignedAccountOpeningForm",
        "Onboarding.Signature",
        "Onboarding.PermanentAddressAsDigilockerAadhaar",
      ])

      if (
        typeof workFlow === "string" &&
        typeof workFlowMap[workFlow]?.txnMethod !== "function"
      ) {
        throw new Error("Failed: Unkown workflow ", workFlow);
      }

      // 1. Ensure SDK is Present
      if (
        typeof window.HyperKycConfig !== "function" ||
        typeof window.HyperKYCModule !== "object"
      ) {
        throw new Error("Failed to detect HV");
      }

      // 2. Get Access Token
      hvGetToken()
        .then((tokenResponse) => {
          let { token: accessToken = null } = tokenResponse;

          // 3. Get HV Transaction ID
          workFlowMap[workFlow]
            .txnMethod()
            .then((txnResponse) => {

              if (!txnResponse || !txnResponse.data?.hypervergeTransactionID) {
                throw new Error("Failed to get HV");
              }

              // 4. Init HV Configuration
              const hyperKycConfig = new window.HyperKycConfig(
                accessToken,
                workFlow,
                txnResponse.data?.hypervergeTransactionID,
              );

              // 5. Set Custom Data Input for HV
              const customInput = workFlowMap[workFlow].payloadMethod(
                userData,
                txnResponse.data
              );
              hyperKycConfig.setInputs(customInput);

              // 6. Set Handler for HV Transaction
              const handler = (HyperKycResult) => {
                switch (HyperKycResult.status) {
                  // ----Complete workflow-----
                  case "auto_approved":
                    resolve(HyperKycResult);
                    break;
                  case "auto_declined":
                  case "user_cancelled":
                  case "error":
                  case "needs_review":
                    // ----Incomplete workflow-----
                    reject(HyperKycResult);
                }
              };

              // 7. Launch HV
              window.HyperKYCModule.launch(hyperKycConfig, handler);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.error(
        "There was a problem with the HyperVerge operation:",
        error
      );
      reject(error);
    }
  });
};
